import { HighlightCodeRef } from "../types";

/**
 * Joins a highlight's code names the way real Word does (yaqatw's
 * WordDocumentHost.applyHighlightUpdate: `codes.map(c => c.attrs.name).join(" | ")`).
 * Shared by the editor tooltip (highlightPlugin.ts) and the exported content
 * control's w:alias (docxExporter.ts). Returns "" (not null) when there's no
 * code data, so callers can `joinCodeNames(h.codes) || fallback`.
 */
export function joinCodeNames(codes: HighlightCodeRef[] | undefined): string {
  if (!codes || codes.length === 0) return "";
  return codes
    .map((c) => c.name)
    .filter(Boolean)
    .join(" | ");
}
